import React from "react";
import "./ProductDescription.css";

export default function ProductDescription({ product }) {

    // If no product or no description, return null or a placeholder
    if (!product || !product.description) {
        return null; // or <p>No description available</p>
    }

    return (
        <div className="product-description">
            <h4 className="section-title">Description</h4>

            <ul className="description-points">
                {product.description.map((point, index) => (
                    <li key={index}>{point}</li>
                ))}
            </ul>
        </div>
    );
}
